import {LocalTemplate} from "../types/templates";

/**
 * Extracts constraints and format information from a WhatsApp API template object.
 */
export const getComponentConstraints = (template: any | null) => {
  if (!template || !template.components) return { hasHeader: false, headerFormat: null, headerContent: null, hasBody: false, bodyText: '', hasFooter: false, footerText: '', hasButtons: false, buttons: [] };
  const comp = (type: string) => template.components.find((c: any) => c.type === type);
  const header = comp('HEADER');
  const body = comp('BODY');
  const footer = comp('FOOTER');
  const btns = comp('BUTTONS');

  let headerContent = null;
  if (header) {
    if (header.format?.toLowerCase() === 'text') {
      headerContent = header.text || header.example?.header_text?.[0] || null;
    } else {
      // the hosted R2/CDN URL stored in template_header_footer_metadata.
      headerContent =
        (template as LocalTemplate)?.template_header_footer_metadata?.header_media_link ||
        header.example?.header_handle?.[0] ||
        header.example?.header_url?.[0] ||
        null;
    }
  }

  return {
    hasHeader: !!header,
    headerFormat: header?.format?.toLowerCase() ?? null,
    headerContent: headerContent,
    hasBody: !!body,
    bodyText: body?.text ?? '',
    hasFooter: !!footer,
    footerText: footer?.text ?? '',
    hasButtons: !!btns,
    buttons: btns?.buttons ?? [],
  };
};

/**
 * Constructs the redirection URL for Meta WhatsApp Message Template Manager.
 * Falls back to base message templates URL if portfolioId or businessAccountId is missing.
 */
export function getMetaCreateTemplateUrl(
  portfolioId?: string | null,
  businessAccountId?: string | null
): string {
  if (portfolioId && businessAccountId) {
    return `https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=${encodeURIComponent(portfolioId)}&tab=message-templates&nav_ref=whatsapp_manager&asset_id=${encodeURIComponent(businessAccountId)}`
  }
  return 'https://business.facebook.com/latest/whatsapp_manager/message_templates'
}